var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6470588,17 L27,32 L5,32 L2.35294118,17 L0,17 L0,11 L32,11 L32,17 L29.6470588,17 Z M11,1.5 L22.5,1.5 L11,1.5 Z M8,17 L8,28 L11,28 L11,17 L8,17 Z M14.5,17 L14.5,28 L17.5,28 L17.5,17 L14.5,17 Z M21,17 L21,28 L24,28 L24,17 L21,17 Z",
    id: "Combined-Shape",
    fill: "#2A2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9372714,-2.84217094e-14 L7.75877048,14.2278145 L4,12.8597339 L8.68056035,-3.01980663e-14 L12.9372714,-2.84217094e-14 Z",
    id: "Combined-Shape",
    fill: "#2A2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2567111,6.61692923e-14 L27.9372714,12.8597339 L24.178501,14.2278145 L19,6.39488462e-14 L23.2567111,6.57252031e-14 Z",
    id: "Combined-Shape",
    fill: "#2A2441"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.b290668bea02967ba8b4283c3bbcd7b4.svg";
export { ForwardRef as ReactComponent };